import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, Users, BadgeCheck, Clock, ArrowRight } from "lucide-react";
import PageHeader from "../components/site/PageHeader";
import { api, WHATSAPP_LINK } from "../lib/api";

export default function Courses() {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    api.get("/courses").then((r) => setCourses(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="courses-page">
      <PageHeader
        eyebrow="Spor Kursları"
        title="Yaş ve Seviyeye Özel Programlar"
        subtitle="Mini sporculardan yetişkinlere uzanan kurs programlarımızda her sporcu adayına uygun bir alan bulunur."
      />

      <section className="section-pad">
        <div className="container-x">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {courses.map((c) => (
              <article
                key={c.id}
                className="card-elev p-6 flex flex-col"
                data-testid={`course-card-${c.id}`}
              >
                <div className="eyebrow mb-3">{c.branch_slug.replace(/-/g, " ")}</div>
                <h3 className="font-display text-2xl font-bold uppercase tracking-tight mb-4">{c.name}</h3>

                <ul className="space-y-2.5 text-sm text-muted-foreground mb-5">
                  <li className="flex items-center gap-2"><Users className="h-4 w-4 text-primary" />{c.age_range}</li>
                  <li className="flex items-center gap-2"><BadgeCheck className="h-4 w-4 text-primary" />{c.level}</li>
                  <li className="flex items-center gap-2"><Clock className="h-4 w-4 text-primary" />{c.schedule}</li>
                  <li className="flex items-center gap-2"><Calendar className="h-4 w-4 text-primary" />Kontenjan: {c.capacity}</li>
                </ul>

                <div className="mt-auto pt-4 border-t border-border flex items-center justify-between">
                  <div>
                    <div className="text-[10px] font-display uppercase tracking-[0.22em] text-muted-foreground">Ücret</div>
                    <div className="font-display font-bold text-primary uppercase tracking-wider">{c.fee}</div>
                  </div>
                  <a
                    href={WHATSAPP_LINK}
                    target="_blank" rel="noreferrer"
                    className="btn-primary text-xs px-4 py-2"
                    data-testid={`course-cta-${c.id}`}
                  >
                    Kayıt Ol <ArrowRight className="h-3 w-3" />
                  </a>
                </div>
              </article>
            ))}
          </div>

          <div className="mt-14 text-center">
            <p className="text-muted-foreground">Aradığın kursu bulamadın mı?</p>
            <Link to="/iletisim" className="btn-secondary mt-4" data-testid="courses-contact">Bize Ulaş</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
